<ul class="menu-items__sections d-block">
  <li class="menu-items__section" (appDeferLoad)="onScroll()">
    @if (data.data?.length) {
      @for (item of data.data; track item; let i = $index) {
        <ul class="menu-items-links" #element>
          <li
            class="menu-items__group menu-items-group menu-items-links__item"
            [class.menu-items-group--active]="
              createCombiIndex(i) === activeIndex
            "
            @fadeInUp
          >
            <a
              class="menu-items-group__link menu-items-links__link"
              appCloseOverlayForActiveLink
              routerLinkActive
              [routerLink]="['/' + localizePath(item?.pretty_url)]"
              [externalLink]="item?.external_url"
            >
              <h3 class="menu-items-group__title">
                {{ item?.title }}
                @if (item?.highlight) {
                  @for (hl of item?.highlight; track hl) {
                    <p
                      class="menu-items-group__sub-title roboto"
                      [innerHTML]="hl"
                    ></p>
                  }
                } @else {
                  @if (item?.short_content) {
                    <p
                      class="menu-items-group__sub-title roboto"
                      [innerHTML]="item?.short_content"
                    ></p>
                  }
                }
              </h3>
            </a>
          </li>
        </ul>
      }
    } @else {
      <h3 class="menu-items-group__not-found">
        {{ 'NOT_FOUND' | translate }}
      </h3>
    }
  </li>
</ul>

@if (isLoading) {
  <div class="spinner spinner--alt text-center mb-5">
    <div class="spinner-grow" role="status">
      <span class="sr-only">{{ 'LOADING' | translate }}</span>
    </div>
  </div>
}
